import { observer } from 'mobx-react'
import { useHistory } from 'react-router'

const DefaultErrorPage = observer(({ error, title, message }) => {
  const { push } = useHistory()
  return (
    <>
      <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
        <div className="max-w-max mx-auto">
          <main className="sm:flex">
            <p className="text-4xl font-extrabold text-green-default sm:text-5xl">
              {error}
            </p>
            <div className="sm:ml-6">
              <div className="sm:border-l sm:border-gray-200 sm:pl-6">
                <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">
                  {title}
                </h1>
                <p className="mt-1 text-base text-gray-500">{message}</p>
              </div>
              <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
                <div
                  className="cursor-pointer inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-green-default hover:bg-green-default-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-default-hover"
                  onClick={() => {
                    push('/')
                  }}
                >
                  Zurück zur Startseite
                </div>
                <a
                  href="https://manual.eneka.de/"
                  className="cursor-pointer inline-flex items-center px-4 py-2 border border-green-default text-sm font-medium rounded-md text-green-default focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-default-hover"
                  target="_blank"
                  rel="noreferrer"
                >
                  Manual
                </a>
                <a
                  href="https://eneka.de/fromapplikation/"
                  className="cursor-pointer inline-flex items-center px-4 py-2 border border-green-default text-sm font-medium rounded-md text-green-default focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-default-hover"
                >
                  Support kontaktieren
                </a>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  )
})

export const NotFoundPage = observer(() => (
  <DefaultErrorPage
    error="404"
    title="Seite nicht gefunden"
    message="Bitte prüfen Sie die URL und versuchen Sie es erneut."
  />
))

export const NotAuthorizedPage = observer(() => (
  <DefaultErrorPage
    error="403"
    title="Nicht berechtigt"
    message="Sie sind zum Zugriff auf diese Seite nicht berechtigt."
  />
))
